import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: snapshots.PdfInclude.
export default class PdfInclude extends Fragment {
  declare [Type]: 'snapshots/pdf-include';

  @attr('boolean', { defaultValue: false })
  declare plpGoals: boolean;

  @attr('boolean', { defaultValue: false })
  declare posts: boolean;

  @attr('boolean', { defaultValue: false })
  declare attendance: boolean;

  @attr('boolean', { defaultValue: false })
  declare badges: boolean;

  @attr('boolean', { defaultValue: false })
  declare goals: boolean;

  @attr('boolean', { defaultValue: false })
  declare progress: boolean;

  @attr('boolean', { defaultValue: false })
  declare assessments: boolean;

  @attr('boolean')
  declare postImages: boolean | undefined;

  @attr('boolean')
  declare reportOnly: boolean | undefined;
}
